const sections = [];

sections.push(
	{
		name: 'login',
		paths: ['/login'],
		module: 'login',
		enableLoggedOut: true,
	},
	{
		name: 'jwt-login',
		paths: ['/jwt-login'],
		module: 'login',
		enableLoggedOut: true,
	},
	{
		name: 'me',
		paths: ['/dashboard', '/'],
		module: 'me',

	},
	{
		name: 'support',
		paths: ['/dashboard/support'],
		module: 'me/support',
	},
	{
		name: 'plan',
		paths: ['/dashboard/plans'],
		module: 'me/plans',
	},
	{
		name: 'admin',
		paths: ['/admin'],
		module: 'admin',
	},
	{
		name: 'rental',
		paths: ['/dashboard/rental'],
		module: 'me/rental',
	},
	{
		name: 'cloud-hosting',
		paths: ['/dashboard/cloud-hosting'],
		module: 'me/cloud-hosting',
	},
	{
		name: 'shopify-development',
		paths: ['/dashboard/shopify-development'],
		module: 'me/web',
	},
	{
		name: 'dispatch',
		paths: ['/dashboard/dispatch'],
		module: 'me/dispatch',
	},
	{
		name: 'cloud-backup',
		paths: ['/dashboard/cloud-backup'],
		module: 'me/cloud-backup',
	},
	{
		name: 'barcode-lookup',
		paths: ['/dashboard/barcode-lookup'],
		module: 'me/barcode-lookup',
	},
	{
		name: 'roam',
		paths: ['/dashboard/roam'],
		module: 'me/roam',
	},
	{
		name: 'kiosk',
		paths: ['/dashboard/kiosk'],
		module: 'me/kiosk',
	},
	{
		name: 'subscriptions',
		paths: ['/dashboard/subscriptions'],
		module: 'me/subscriptions',
	},
	{
		name: 'visual-deck',
		paths: ['/dashboard/visual-deck'],
		module: 'me/visual-deck',
	},
	{
		name: 'universal-importer',
		paths: ['/dashboard/universal-importer'],
		module: 'me/universal-importer',
	},
	{
		name: 'tspay',
		paths: ['/dashboard/tspay'],
		module: 'me/tspay',
	},
);

module.exports = sections;
